import Vue from 'vue';

Vue.directive('can', {
    bind: function (el, binding, vnode) {
        if (
            (
                Array.isArray(binding.value)
                && Vue.prototype.$auth.user().roles
                .filter(value => binding.value.includes(value)).length === 0
            ) || (
                !Array.isArray(binding.value)
                && !Vue.prototype.$auth.user().roles.includes(binding.value)
            )
        ) {
            vnode.elm.style.display = "none";
        }
    }
})
